/**
 * @generated SignedSource<<33c1e095b3ab9dddb0f56185d14d4943>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CreateQuoteContentBlockInput = {
  sectionType: string;
  name: string;
  bodyJson: string;
  schemaVersion?: number | null;
  isDefault?: boolean | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type createQuoteContentBlockMutation$variables = {
  input: CreateQuoteContentBlockInput;
};
export type createQuoteContentBlockMutation$data = {
  readonly createQuoteContentBlock: {
    readonly company: {
      readonly id: string;
      readonly quoteContentBlocks: ReadonlyArray<{
        readonly id: string;
        readonly sectionType: string | null;
        readonly name: string | null;
        readonly bodyJson: string | null;
        readonly isDefault: boolean | null;
      } | null> | null;
    } | null;
    readonly quoteContentBlock: {
      readonly id: string;
      readonly sectionType: string | null;
      readonly name: string | null;
      readonly bodyJson: string | null;
      readonly isDefault: boolean | null;
    } | null;
  } | null;
};
export type createQuoteContentBlockMutation = {
  variables: createQuoteContentBlockMutation$variables;
  response: createQuoteContentBlockMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  (v1/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "sectionType",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "bodyJson",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isDefault",
    "storageKey": null
  }
],
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateQuoteContentBlockPayload",
    "kind": "LinkedField",
    "name": "createQuoteContentBlock",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Company",
        "kind": "LinkedField",
        "name": "company",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "QuoteContentBlock",
            "kind": "LinkedField",
            "name": "quoteContentBlocks",
            "plural": true,
            "selections": (v2/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "QuoteContentBlock",
        "kind": "LinkedField",
        "name": "quoteContentBlock",
        "plural": false,
        "selections": (v2/*: any*/),
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "createQuoteContentBlockMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "createQuoteContentBlockMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "19e08eaa2702f22bea3e0e569fb44cf0",
    "id": null,
    "metadata": {},
    "name": "createQuoteContentBlockMutation",
    "operationKind": "mutation",
    "text": "mutation createQuoteContentBlockMutation(\n  $input: CreateQuoteContentBlockInput!\n) {\n  createQuoteContentBlock(input: $input) {\n    company {\n      id\n      quoteContentBlocks {\n        id\n        sectionType\n        name\n        bodyJson\n        isDefault\n      }\n    }\n    quoteContentBlock {\n      id\n      sectionType\n      name\n      bodyJson\n      isDefault\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "48729f7c91f9cb917729d8e2856cc715";

export default node;
